import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import $ from 'jquery';
import { mask } from 'vue-the-mask';


@Component({
    directives: {
        mask
    }
})
export default class Input extends Vue {
    @Prop()
    type!: string;

    @Prop()
    regex!: string;

    @Prop()
    mask!: string;

    @Prop()
    value!: string;

    @Prop()
    id!: number;

    @Prop()
    title!: string;

    @Prop()
    maxlength!: number;

    @Prop()
    isRequired: boolean = false;

    @Prop()
    isDisabled: boolean = false;

    customMasks: object = {
        mask: this.mask,
        tokens: {
            '.': { pattern: /./ },
            '#': { pattern: /\d/ },
            X: { pattern: /[0-9a-zA-Z]/ },
            Y: { pattern: /[a-zA-Z\- ]/},
            S: { pattern: /[a-zA-Z]/ },
            A: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
            a: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
            '!': { escape: true }
        }
    }

    mounted() {
        if (this.id != undefined) {
            $('input#' + this.id).removeClass('valid').removeClass('invalid');
            $('label#' + this.id).removeClass('valid-text').removeClass('invalid-text');
        }

        (this.customMasks as any).mask = this.mask;
        if (this.value == undefined)
            this.value = '';
    }

    onChange(e: any) {
        if (this.regex != undefined)
            if (!RegExp(this.regex).test(e.target.value)) {

                ('rejected');
                $('input#' + this.id).removeClass('valid').addClass('invalid');
                $('label[for=' + this.id + ']').removeClass('valid-text').addClass('invalid-text');

            }
            else {
                console.log('validated');
                $('input#' + this.id).removeClass('invalid').addClass('valid');
                $('label[for=' + this.id + ']').removeClass('invalid-text').addClass('valid-text');
            }

    }
}



// WEBPACK FOOTER //
// ./src/atomicComponents/Input/Input.ts